<template>
  <tbody :style="{ 'background-color': color }">
    <td :colspan="cols" style="border-bottom: 1px black solid">
      <p>
        Pickeado por:
        <strong class="separador-texto">{{ responsable }}</strong>
        Tipo Pedido:
        <strong class="separador-texto-corto">{{ pedido.tipoPedido }}</strong>
        Zona:
        <strong class="separador-texto">{{ zona }}</strong>
        Estado:
        <strong class="separador-texto-corto">{{ pedido.estado }}</strong>
      </p>
    </td>
    <cierre-detalle-item
      v-for="item in pedidoItems"
      :key="`item-con-stock-${item.id}`"
      :item="item"
      :es-item-actual="esItemActual(item.id)"
      :es-pedido-cerrado="esPedidoCerrado"
      @move-next="changeItemFocusHandle"
    />
  </tbody>
</template>

<script>
import { format, parseISO } from 'date-fns'
import { mapGetters } from 'vuex'

import CierreDetalleItem from '@/components/cierre/CierreDetalleItem.vue'

export default {
  name: 'CierreDetalleGrupo',
  components: {
    CierreDetalleItem
  },
  props: {
    pedido: {
      type: Object,
      required: true
    },
    color: {
      type: String,
      required: true
    },
    esGrupoActual: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      itemActual: 0
    }
  },
  computed: {
    ...mapGetters('sesion', ['bodega']),
    fechaEmision() {
      return format(parseISO(this.pedido.fechaEmision), 'dd/MM/yyyy')
    },
    fecha() {
      return format(parseISO(this.pedido.fecha), 'dd/MM/yyyy HH:mm:ss')
    },
    responsable() {
      return this.pedido.responsable
        ? this.pedido.responsable.nombre
        : 'No asignado'
    },
    titulo() {
      return `Ítems${this.esSubpedido ? ` subpedido #${this.pedido.id}` : ''}`
    },
    zona() {
      if (this.pedido.zona) return this.pedido.zona.nombre
      return this.pedido.tipoPedido === 'Múltiple' ? 'Varias' : 'Sin Zona'
    },
    esPedidoCerrado() {
      const estados = ['despachado', 'cerrado', 'cancelado']
      return estados.includes(this.pedido.estado.toLowerCase())
    },
    esUsuarioMonitor() {
      // Si usuario tiene rol Monitor, no se muestran acciones
      return this.bodega.roles.some((rol) => rol.id === 6)
    },
    cols() {
      return this.esUsuarioMonitor ? 10 : 11
    },
    pedidoItems() {
      const items = this.pedido.items.filter((x) => !x.pedidoItemKitId) || []
      for (const item of items) {
        const partes = this.pedido.items.filter(
          (i) => i.pedidoItemKitId === item.id
        )
        item.partes = partes
      }
      return items
    }
  },
  watch: {
    // Al inicio, dar foco al primer ítem
    esGrupoActual(seleccionado) {
      this.checkCambioGrupo(seleccionado)
    }
  },
  mounted() {
    // Al inicio, dar foco al primer ítem
    this.checkCambioGrupo(this.esGrupoActual)
  },
  methods: {
    checkCambioGrupo(seleccionado) {
      if (seleccionado) {
        this.itemActual = this.pedido.items[0].id
      }
    },
    esItemActual(id = 0) {
      return id === this.itemActual
    },
    changeItemFocusHandle(payload) {
      const index =
        this.pedido.items.findIndex((item) => item.id === payload) + 1
      if (typeof this.pedido.items[index] === 'undefined') {
        this.itemActual = 0
        this.$emit('next-group', this.pedido.id)
      } else {
        this.itemActual = this.pedido.items[index].id
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.botonera {
  margin-bottom: 0.5em;
}

.cabecera-detalle {
  margin-top: 15px;
  margin-bottom: 20px;
}
.separador-texto {
  display: inline-block;
  width: 14em;
}
.separador-texto-corto {
  display: inline-block;
  width: 8em;
}
</style>
